export const JSON_HEADERS = {
  'Content-Type': 'application/json',
} as const;

export const MULTIPART_HEADERS = {
  'Content-Type': 'multipart/form-data',
} as const;

export const BLOB_CONFIG = {
  responseType: 'blob' as const,
};